module.exports = __webpack_public_path__ + "img/bg14.e251d552.jpg";